import { render } from "./App.vue?vue&type=template&id=30286f09"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30286f09&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__